<template>
    <div class="modal-card" style="width: auto">
        <header class="modal-card-head">
            <p class="modal-card-title" style="margin: 0px;">Workspace settings</p>
        </header>
        <section class="modal-card-body change-password-modal">
            <div class="row">
                <div class="col-xs-12">
                    <b-field label="Name">                     
                        <b-input type="text" v-model="workspace.name" maxlength="50" required></b-input>
                    </b-field>
                </div>
            </div>
        </section>
        <footer class="modal-card-foot" style="text-align: right;">
            <button class="button" type="button" @click="$parent.close()">Close</button>
            <button class="button is-primary" @click="emitEvent">Save</button>
        </footer>
    </div>
</template>

<script>

let workspace_payload = {

}

export default {
    name: 'ModalWorkspaceSettings',
    props: {
        workspace: Object,
    },
    data(){
        return {
            workspace_payload: workspace_payload
        }
    },
    components: {},
    methods:{
        emitEvent: function(){
            workspace_payload["name"] = this.workspace.name
            this.$emit('workspace_saved', workspace_payload);
            this.$parent.close();
        },
    },
    mounted: function () {
    }
}
</script>

<style scoped>
    .priority-list li{
        display: inline-block;
        margin-left: -1px;
    }
    .priority-list li >>> .button{
        border-radius: 0px;
        font-size: 14px;
    }
    .priority-list li >>> label{
        font-weight: 400;
        margin: 0px;
    }
    .change-password-modal >>> .input{
        max-width: 100%;
        width: 350px;
    }
    .change-password-modal >>> .label{
        font-weight: 400;
        text-align: left;
        padding-left: 0px;
    }
    .change-password-modal >>> .field{
        margin-bottom: 20px;
    }
</style>
